module.exports = __webpack_public_path__ + "UX20.png?2d2cea1b9462c20c381d325ed2f188c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX20.png
// module id = 70
// module chunks = 0